<section aria-label="account connections">
  <div class="row">
    <div class="col-12">
      @if (!compact) {
        <fui-heading [text]="'discord.connections_heading' | translate" [level]="5"></fui-heading>
        <p class="m-y-15">{{ "discord.intro" | translate }}</p>
      }

      @if (message) {
        <div class="connections-message m-y-15" [class.success]="messageType == 'success'" [class.error]="messageType == 'error'" role="status">
          {{ message }}
        </div>
      }

      @if (loading) {
        <myp-inline-loader [loading]="loading" height="120px" spinnerName="discord-status"></myp-inline-loader>
      }

      @if (!loading) {
        <div class="connection-row d-flex align-items-center justify-content-between p-20" [class.linked]="linked">
          <div class="connection-info d-flex align-items-center">
            <span class="discord-mark" [class.linked]="linked" aria-hidden="true">
              <svg viewBox="0 -28.5 256 256" xmlns="http://www.w3.org/2000/svg">
                <path
                  fill="currentColor"
                  d="M216.856 16.597A208.502 208.502 0 0 0 164.042 0c-2.275 4.113-4.933 9.645-6.766 14.046-19.692-2.961-39.203-2.961-58.533 0-1.832-4.4-4.55-9.933-6.846-14.046a207.809 207.809 0 0 0-52.855 16.638C5.618 67.147-3.443 116.4 1.087 164.956c22.169 16.555 43.653 26.612 64.775 33.193A161.094 161.094 0 0 0 79.735 175.3a136.413 136.413 0 0 1-21.846-10.632 108.636 108.636 0 0 0 5.356-4.237c42.122 19.702 87.89 19.702 129.51 0a131.66 131.66 0 0 0 5.355 4.237 136.07 136.07 0 0 1-21.886 10.653c4.006 8.02 8.638 15.67 13.873 22.848 21.142-6.58 42.646-16.637 64.815-33.213 5.316-56.288-9.08-105.09-38.056-148.36ZM85.474 135.095c-12.645 0-23.015-11.805-23.015-26.18s10.149-26.2 23.015-26.2c12.867 0 23.236 11.804 23.015 26.2.02 14.375-10.148 26.18-23.015 26.18Zm85.051 0c-12.645 0-23.014-11.805-23.014-26.18s10.148-26.2 23.014-26.2c12.867 0 23.236 11.804 23.015 26.2 0 14.375-10.148 26.18-23.015 26.18Z"
                />
              </svg>
            </span>
            <div class="m-l-15">
              <div class="connection-title">Discord</div>
              @if (linked && discordLink) {
                <div class="connection-detail">
                  {{ "discord.linked_as" | translate }}
                  <strong>{{ discordLink.discordUsername || discordLink.discordId }}</strong>
                  @if (discordLink.verified) {
                    <span class="verified-badge m-l-8">
                      <fa-icon icon="check"></fa-icon>
                      {{ "discord.server_member" | translate }}
                    </span>
                  } @else {
                    <span class="unverified-badge m-l-8">{{ "discord.not_verified" | translate }}</span>
                  }
                </div>
              } @else {
                <div class="connection-detail muted">{{ "discord.not_connected" | translate }}</div>
              }
            </div>
          </div>

          <div class="connection-action">
            @if (linked) {
              <button class="btn btn-secondary" [disabled]="working" (click)="unlink()">
                {{ working ? ("discord.working" | translate) : ("discord.unlink" | translate) }}
              </button>
            } @else {
              <button class="btn btn-discord d-inline-flex align-items-center" [disabled]="working" (click)="connect()">
                <span class="discord-mark-sm" aria-hidden="true">
                  <svg viewBox="0 -28.5 256 256" xmlns="http://www.w3.org/2000/svg">
                    <path
                      fill="currentColor"
                      d="M216.856 16.597A208.502 208.502 0 0 0 164.042 0c-2.275 4.113-4.933 9.645-6.766 14.046-19.692-2.961-39.203-2.961-58.533 0-1.832-4.4-4.55-9.933-6.846-14.046a207.809 207.809 0 0 0-52.855 16.638C5.618 67.147-3.443 116.4 1.087 164.956c22.169 16.555 43.653 26.612 64.775 33.193A161.094 161.094 0 0 0 79.735 175.3a136.413 136.413 0 0 1-21.846-10.632 108.636 108.636 0 0 0 5.356-4.237c42.122 19.702 87.89 19.702 129.51 0a131.66 131.66 0 0 0 5.355 4.237 136.07 136.07 0 0 1-21.886 10.653c4.006 8.02 8.638 15.67 13.873 22.848 21.142-6.58 42.646-16.637 64.815-33.213 5.316-56.288-9.08-105.09-38.056-148.36ZM85.474 135.095c-12.645 0-23.015-11.805-23.015-26.18s10.149-26.2 23.015-26.2c12.867 0 23.236 11.804 23.015 26.2.02 14.375-10.148 26.18-23.015 26.18Zm85.051 0c-12.645 0-23.014-11.805-23.014-26.18s10.148-26.2 23.014-26.2c12.867 0 23.236 11.804 23.015 26.2 0 14.375-10.148 26.18-23.015 26.18Z"
                    />
                  </svg>
                </span>
                {{ working ? ("discord.connecting" | translate) : ("discord.connect" | translate) }}
              </button>
            }
          </div>
        </div>

        <!-- Shown before linking, not after: this is the moment the member can still
             choose. Linking reattributes their imported Discord posts and reactions to
             their myFender name, and that is NOT undone by unlinking later
             (DISCORD-MIGRATION-PLAN.md 4.7 — first claim wins, unlink never reverts).
             Saying so plainly is the difference between a choice and a surprise. -->
        @if (!linked && !loading) {
          <div class="link-notice p-20 m-t-15">
            <div class="link-notice-title">{{ "discord.before_you_link" | translate }}</div>
            <div class="link-notice-detail">{{ "discord.name_change_notice" | translate }}</div>
          </div>
        }

        <!-- One-time Fender Studio Pro gift for linked, guild-verified members. -->
        @if (canRedeem) {
          <div class="gift-row p-20 m-t-15">
            <div class="gift-copy">
              <div class="gift-title">{{ "discord.gift_title" | translate }}</div>
              <div class="gift-detail">{{ "discord.gift_detail" | translate }}</div>
            </div>
            <button class="btn btn-primary gift-btn" [disabled]="redeeming" (click)="redeem()">
              {{ redeeming ? ("discord.redeeming" | translate) : ("discord.redeem" | translate) }}
            </button>
          </div>
        }

        @if (giftRedeemed) {
          <div class="gift-row redeemed p-20 m-t-15">
            <div class="gift-copy">
              <div class="gift-title">
                <fa-icon icon="check"></fa-icon>
                {{ "discord.gift_redeemed_title" | translate }}
              </div>
              <div class="gift-detail">{{ "discord.gift_redeemed_detail" | translate }}</div>
            </div>
          </div>
        }

        <!-- Eligible except for the hardware requirement: prompt them to register their TMP. -->
        @if (needsToneMasterPro) {
          <div class="gift-row locked p-20 m-t-15">
            <div class="gift-copy">
              <div class="gift-title">{{ "discord.gift_needs_tmp_title" | translate }}</div>
              <div class="gift-detail">{{ "discord.gift_needs_tmp_detail" | translate }}</div>
            </div>
            <button class="btn btn-primary gift-btn" (click)="registerToneMasterPro()">
              {{ "discord.register_product" | translate }}
            </button>
          </div>
        }

        @if (needsGuildMembership) {
          <div class="gift-row locked p-20 m-t-15">
            <div class="gift-copy">
              <div class="gift-title">{{ "discord.gift_locked_title" | translate }}</div>
              <div class="gift-detail">{{ "discord.gift_locked_detail" | translate }}</div>
            </div>
          </div>
        }
      }
    </div>
  </div>
</section>
